// extracted by mini-css-extract-plugin
export default {"experts":"experts_experts__PPI3A","expert_image":"experts_expert_image__1CcI3","expert_name":"experts_expert_name__g8Vt3","expert_description":"experts_expert_description__gfyq9"};